module.exports = __webpack_public_path__ + "img/file-diff.d74fabd7.svg";